export default [
  {
    path: '/admin/defines/bank-accoounts',
    name: 'BankAccounts',
    component: () => import('@/views/Admin/Defines/Bank_accounts/Index.vue'),
    meta: {
      pageTitle: 'Banka Hesapları',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/bank-accoounts/add',
    name: 'BankAccountAdd',
    component: () => import('@/views/Admin/Defines/Bank_accounts/Add.vue'),
    meta: {
      pageTitle: 'Banka Hesapları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/bank-accoounts',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/bank-accoounts/edit/:id',
    name: 'BankAccountEdit',
    component: () => import('@/views/Admin/Defines/Bank_accounts/Edit.vue'),
    meta: {
      pageTitle: 'Banka Hesapları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/bank-accoounts',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
]
